import React from "react";

function clearNonCriticalCaches() {
  try {
    const storage = window.localStorage;
    const keys = [];
    for (let i = 0; i < storage.length; i += 1) {
      const key = storage.key(i);
      if (!key) continue;
      if (key === "tw_favs" || key === "tw_requests") {
        keys.push(key);
      }
    }
    keys.forEach((key) => storage.removeItem(key));
  } catch {}

  try {
    window.sessionStorage.removeItem("tw_pwa_dismissed");
    window.sessionStorage.removeItem("tw_welcome_continued");
  } catch {}
}

export default class RenderErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error) {
    console.error("Team Work render error", error);
  }

  repairAndReload = () => {
    clearNonCriticalCaches();
    window.location.replace("/");
  };

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <main className="min-h-screen bg-[#f7f9fc] px-6 py-20 flex items-center justify-center">
        <section className="w-full max-w-xl rounded-3xl bg-white border border-slate-200 shadow-xl p-8 text-center">
          <div className="mx-auto h-12 w-12 rounded-2xl bg-[#fff0e8] text-[#fe6c09] flex items-center justify-center text-xl font-bold">!</div>
          <h1 className="mt-5 text-2xl font-bold text-[#0e253a]">Un problème d’affichage est survenu</h1>
          <p className="mt-3 text-sm leading-6 text-slate-600">Une ancienne donnée enregistrée dans le navigateur peut empêcher l’affichage. Team Work peut la réparer sans supprimer votre compte.</p>
          <div className="mt-6 flex flex-col justify-center gap-3 sm:flex-row">
            <button type="button" onClick={this.repairAndReload} className="rounded-xl bg-[#0e253a] px-5 py-3 text-sm font-semibold text-white hover:bg-[#173c59]">Réparer et réessayer</button>
            <button type="button" onClick={() => window.location.reload()} className="rounded-xl border border-slate-200 bg-white px-5 py-3 text-sm font-semibold text-[#0e253a] hover:bg-slate-50">Actualiser</button>
          </div>
        </section>
      </main>
    );
  }
}
